	angular
	  .module('vppApp')
	  .service('ServerNodeStore', ServerNodeStore);

		ServerNodeStore.$inject = ['$rootScope'];

		function ServerNodeStore($rootScope) {
			var serverNodeInfo = {};
			$rootScope.NodeData = {};

	    var _createNodeObj = function (NodeInf) {
			 $rootScope.NodeData = {
        		Node: NodeInf.vppNode,
        		Time: NodeInf.respondedTime
        };
		 };
     // Recreate data Obj for page refresh
      var _reCreateNodeObj = function (NodeInf) {
        $rootScope.NodeData = {
        		Node: NodeInf.vppNode,
        		Time: NodeInf.respondedTime
        };
      };
	  ServerNodeStore.addNode = function(NodeInf) {
	    // create userObj from success 
	    _createNodeObj(NodeInf);
	    // sets localStorage data
	    window.localStorage["vppDataNode"] = angular.toJson($rootScope.NodeData);
	    // sets sessionStorage data
	    window.sessionStorage["vppDataNode"] = angular.toJson($rootScope.NodeData);
	  };
	  ServerNodeStore.getNodeInstance = function() {
	    var _NodeCode = $rootScope.NodeData.Node;
	    return _NodeCode;
	  };

	  ServerNodeStore.checkNodeExists = function () {
		 if (Object.keys($rootScope.NodeData).length === 0) {
			 var _tempSVNData = angular.fromJson(window.sessionStorage.getItem("vppDataNode"));
			 var _tempLVNData = angular.fromJson(window.localStorage.getItem("vppDataNode"));

			 if (_tempSVNData && _tempLVNData) {
					_reCreateNodeObj(_tempLVNData.Node);
			 } 
			 // end
		 }

	 };

	  return ServerNodeStore;


	}





